import { useState } from "react";

import { Command, DropdownMenu, SelectButton, Text } from "@vericus/cadmus-ui";

import { IssueStatus } from "@/generated/graphql";

import { StatusCell } from "../issue/status-dropdown";

interface DropdownOption {
  value: string;
  text: string;
}

interface SimpleDropdownProps {
  selected?: string;
  kind: string;
  items: DropdownOption[];
  onSelect: (value: string) => void;
  placeholder?: string;
}

export function SimpleDropdown({
  selected,
  kind,
  items,
  onSelect,
  placeholder = "Select",
}: SimpleDropdownProps) {
  const selectedText =
    items.find((option) => option.value === selected)?.text ?? placeholder;

  const [open, setOpen] = useState<boolean>(false);

  return (
    <DropdownMenu.Root open={open} onOpenChange={(open) => setOpen(open)}>
      <DropdownMenu.Trigger asChild>
        <SelectButton>
          <Text
            kind="bodyLine"
            as="div"
            style={{ wordWrap: "break-word", maxWidth: 200 }}
          >
            {selectedText}
          </Text>
        </SelectButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content>
        <Command.Root style={{ height: "100%", width: 330 }}>
          <Command.List>
            <Command.Group>
              {items.map((item) => (
                <Command.RadioItem
                  key={item.value}
                  value={item.value}
                  onSelect={() => {
                    onSelect(item.value);
                    setOpen(false);
                  }}
                  data-selected={selected === item.value ? "true" : undefined}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 12,
                    padding: 8,
                  }}
                >
                  <Text
                    kind="bodyMd"
                    style={{ maxWidth: 250, wordWrap: "break-word" }}
                  >
                    {kind === "status" ? (
                      <StatusCell status={item.value as IssueStatus} />
                    ) : (
                      item.text
                    )}
                  </Text>
                </Command.RadioItem>
              ))}
            </Command.Group>
          </Command.List>
        </Command.Root>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
